/**
 * Defines actions related to Primary Navigation bar feature.
 */

import * as types from 'constants/ActionTypes';

export const getMfaConfigAction = () => ({
  type: types.MFA_CONFIG_REQUESTED,
});

export const getUserDetails = (fetchUserApp) => ({
  type: types.USER_DETAILS_REQUESTED,
  fetchUserApp,
});

export const toggleSidebarShowAction = () => ({
  type: types.TOGGLE_SIDEBAR_SHOW,
});

export const toggleFullscreenAction = (payload) => ({
  type: types.SET_FULL_SCREEN,
  payload,
});

export const toggleSidebarHideAction = () => ({
  type: types.TOGGLE_SIDEBAR_HIDE,
});

export const getLoaders = () => ({
  type: types.LOADERS_REQUESTED,
});

export const navigateAction = (payload) => ({
  type: types.NAVIGATE,
  payload,
});

export const pollUnreadNotifications = (payload) => ({
  type: types.NOTIFICATIONS_POLL,
  payload,
});

export const pollUnreadNotificationsResponded = (payload) => ({
  type: types.NOTIFICATIONS_POLL_RESPONDED,
  payload,
});

export const navigationBlockerAction = () => ({
  type: types.NAVIGATION_BLOCKER,
});
export const navigationUnBlockerAction = () => ({
  type: types.NAVIGATION_UNBLOCKER,
});
export const setPreviousPathAction = (payload) => ({
  type: types.SET_PREVIOUS_PATH,
  payload,
});

export const setFeatureFlagLoaded = (payload) => ({
  type: types.SET_FEATURE_FLAGS_LOADED,
  payload,
});

export const setShowNewUI = (payload) => ({
  type: types.SET_SHOW_NEW_UI,
  payload,
});

/** #genai */
export const setEvoneBannerVisibility = (visible) => ({
  type: types.SET_EVONE_BANNER_VISIBILITY,
  payload: Boolean(visible),
});

/** #genai */
export const setEvoneLdShowBanner = (enabled) => ({
  type: types.SET_EVONE_LD_SHOW_BANNER,
  payload: Boolean(enabled),
});

// #genai shared-resource flow: fetch app details (with optional entitlement fallback)
export const fetchSharedAppConfig = (payload) => ({
  type: types.FETCH_SHARED_APP_CONFIG,
  payload,
});

// #genai guest user profile via v2 API
export const getGuestUserDetails = () => ({
  type: types.GUEST_USER_DETAILS_REQUESTED,
});
